export const environment = {
  appname: 'Euphoria Lane',
  host: 'https://euphlane.com',
  ig: 'https://www.instagram.com/euphlane',
  email: 'support@euphlane.com',
  address1: '1401 21st St #13391',
  address2: 'Sacramento, CA 95811',
  free_shipping_threshold: 300,
  api: {
    host: 'https://euphlane.com/api',
    s3endpoint: 'https://storage.euphlane.com',
  },
  google: {
    reCaptcha: {
      siteKey: '6Lcvg8UsAAAAAG0hCp4JTAEGNIghcXc9anGZqv9V',
    },
    oauth: {
      clientID:
        '642873476515-8omfsng7qg9l2nrlmt3bhn3urefqgasc.apps.googleusercontent.com',
    },
    api: {
      place: 'AIzaSyCL2N48eT0s1oeO4d5SKi3WBTLUlvEtKXM',
    },
  },
  stripe: {
    apikey:
      'pk_live_51TOu7MAEFDlGV411WkOmeYqr4MTzox1s8slbMpI14PfSxUb4USrHiDZaPHCDiKdykZmXUDXhmRkEwqfIZALh07gG00hBLZtlLD',
  },
};
